/**
 * Map redux data to a new array compatible
 * with material-table props.
 * https://stackoverflow.com/questions/65396030/using-material-table-with-redux-state
 * @param data
 */
export const mapTableData = (data) => data.map((item) => Object.assign({}, item));

/**
 * group same data from array
 * @param array
 * @param key
 */
export const groupBy = (array, key) => {
  return array.reduce((result, obj) => {
    (result[obj[key]] = result[obj[key]] || []).push(obj);
    return result;
  }, []);
};

export const delay = (s) =>
  new Promise((r) => {
    setTimeout(() => r(), s * 1000);
  });
export const normalizeKey = (str) => (str || "").toString().toLowerCase().replace(/[\s_-]+/g, "");

export const convertPermissionsToArray = (permissionsObject, existingPermissions = []) => {
  if (!permissionsObject || typeof permissionsObject !== "object") return [];

  const result = [];
  existingPermissions.forEach((perm) => {
    const targetModuleNorm = normalizeKey(perm.module);
    const targetNameNorm = normalizeKey(perm.name);

    for (const [modKey, modVal] of Object.entries(permissionsObject)) {
      if (normalizeKey(modKey) === targetModuleNorm && modVal && typeof modVal === "object") {
        for (const [nameKey, val] of Object.entries(modVal)) {
          if (normalizeKey(nameKey) === targetNameNorm && Boolean(val)) {
            result.push({
              id: perm.id,
              name: perm.name,
              module: perm.module,
              default: true,
            });
          }
        }
      }
    }
  });

  return result;
};

export const formatDeliveryNotes = (deliveryNotes) => {
  if (!deliveryNotes || !Array.isArray(deliveryNotes) || deliveryNotes.length === 0) {
    return { numbers: "", packages: "" };
  }

  const numbers = deliveryNotes
    .map((note) => note?.delivery_note_number || "")
    .filter(Boolean)
    .join(", ");

  const packages = deliveryNotes
    .map((note) => note?.packages || "")
    .filter(Boolean)
    .join(", ");

  return { numbers, packages };
};
export const translatePermission = (t, module, permName) => {
  if (!permName) return "";

  const mod = (module || "").toString().toLowerCase();
  const compositeKey = mod ? `${mod}.${permName}` : permName;

  const translated = t(compositeKey);
  if (translated !== compositeKey) {
    return translated;
  }

  return t(permName);
};

export const formatSnakeCaseToTitle = (str) => {
  if (!str) return '';
  return str
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');

};

export const getTourDeliveryTimings = (tour) => {
  if (Array.isArray(tour?.delivery_timing_configs) && tour.delivery_timing_configs.length) {
    return [
      ...new Set(
        tour.delivery_timing_configs.map((config) => config.delivery_timing).filter(Boolean)
      ),
    ];
  }
  return Array.isArray(tour?.delivery_timings) ? tour.delivery_timings : [];
};